import { ReactElement } from "react";
import NewButton from "../../../components/Atomos/Buttons/newButton";
import { SecondmentCatalogResult } from "../../../Services/PublicSecondments";
import SecondmentsCard from "./SecondmentsCard";
import SecondmentsPager from "./SecondmentsPager";
import SecondmentsSearchForm from "./SecondmentsSearchForm";

interface SecondmentsListProps {
  catalog: SecondmentCatalogResult | null;
  loading: boolean;
  error: string;
}

export default function SecondmentsList({ catalog, loading, error }: SecondmentsListProps): ReactElement {
  const posting = catalog?.mode === "postings";
  return (
    <section>
      <h2 className="secondments-heading" id="search">Secondment Search</h2>
      <SecondmentsSearchForm options={catalog?.options ?? null} />
      <div className="secondments-toolbar">
        <a href="/manage_secondments.asp?action=add">
          <NewButton text="Submit a Secondment" color="primary" style="outlined" />
        </a>
        {catalog ? <SecondmentsPager page={catalog.page} pageCount={catalog.pageCount} /> : null}
      </div>
      {loading ? <p>Loading secondments...</p> : null}
      {error ? <p className="secondments-error">{error}</p> : null}
      {posting && catalog?.header ? (
        <article className="secondments-card">
          <p className="secondments-label">Secondment Program Overview:</p>
          <p>{catalog.header.excerpt}</p>
        </article>
      ) : null}
      {catalog && catalog.items.length === 0 && !loading ? <p className="secondments-empty">No Secondment matches with search criteria</p> : null}
      {catalog?.items.map((card) => (
        <SecondmentsCard key={posting ? card.secId : card.firmId} card={card} posting={Boolean(posting)} />
      ))}
      {catalog ? <SecondmentsPager page={catalog.page} pageCount={catalog.pageCount} /> : null}
      <img className="secondments-dots" src="https://members-legacy.worldservicesgroup.com/assets/images/dots.png" alt="dots" />
    </section>
  );
}
